





































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { splitThousands, emptyToLine } from "@/utils/common";
import dayjs from "dayjs";
const app = namespace("app");
const user = namespace("user");
const dashboard = namespace("dashboard");
const service = namespace("service");

@Component({})
export default class Dashboard extends Vue {
  @app.State test;
  @user.State userData;
  @dashboard.Action getHomeOrderData;
  @dashboard.Action getHomeCustomerData;
  @dashboard.Action getOrderStatistic;
  @service.Action getAppointmentCalender;
  splitThousands = splitThousands;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  get statusBarData() {
    return [
      {
        statusName: this.$t("dashboard.wait-take-out"),
        statusNum: this.orderNums[0]
      },
      {
        statusName: this.$t("dashboard.waiting"),
        statusNum: this.orderNums[1]
      },
      {
        statusName: this.$t("dashboard.settlement"),
        statusNum: this.orderNums[2]
      }
    ];
  }
  orderNums: number[] = [0, 0, 0];
  taskList: any[] = [];
  currentStatus: number = 0;
  orderData: any = [];
  customerData: any = [];
  orderListData: any[] = [];
  freshDate: string = "";
  weekDataList: any = []; // 最近七天数据
  currentLookDay: string = dayjs().format("DD");
  loadingStatistic: boolean = false; // 首页统计数据加载完成控制
  created() {
    this.init();
  }
  handleLink(url) {
    this.$router.push(url);
  }
  //更改tab只有complete可以跳转
  handleLinkOrderInfo(id) {
    if (this.currentStatus === 0) {
      this.$router.push(`/service/view/${id}`);
    }
    if (this.currentStatus === 1) {
      this.$router.push(`/service/view/${id}`);
    }
    if (this.currentStatus === 2) {
      this.$router.push(`/service/view/${id}`);
    }
    return;
  }
  handleLinkCustomer(task) {
    if (!task.customerCode) return false;
    this.$router.push(`/setting/customer-view/${task.customerCode}?vehicleCode=${task.vehicleCode}`);
  }
  hasTmallOrder: boolean = false;
  weekDescMap: any = {
    "1": window._I18N.t("base.monday"),
    "2": window._I18N.t("base.tuesday"),
    "3": window._I18N.t("base.wednesday"),
    "4": window._I18N.t("base.thursday"),
    "5": window._I18N.t("base.friday"),
    "6": window._I18N.t("base.saturday"),
    "0": window._I18N.t("base.sunday")
  };
  init() {
    this.freshDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.getHomeOrderData().then(data => {
      this.orderData = data.data;
      // console.log(this.orderData,"2222");
    });
    this.getHomeCustomerData().then(data => {
      this.customerData = data.data;
    });
    this.getLastOneWeekAppointment();
    this.loadingStatistic = true;
    //订单状态接口
    this.getOrderStatistic()
      .then(data => {
        this.orderNums = [data.data.receivedCount, data.data.processedCount, data.data.completedCount];
        this.orderListData = [
          data.data.receivedOrderArray,
          data.data.processedOrderArray,
          data.data.completedOrderArray
        ];
        this.hasTmallOrder = data.data.unfinishedOrderArray.some(item => {
          return item.orderSource === "2";
        });
        this.handleSwitchStatus(1);
      })
      .finally(() => {
        this.loadingStatistic = false;
      });
  }
  refreshData() {
    this.init();
  }
  getLastOneWeekAppointment() {
    this.getAppointmentCalender({
      queryDays: 7
    }).then(data => {
      let appointmentList = data.data.list || [];
      let tempWeekData = [];
      let curDate = dayjs();
      for (let index = 0; index < 7; index++) {
        let tempDate = curDate.add(index, "day");
        let fullDateStr = tempDate.format("YYYYMMDD");
        let reuslt = appointmentList.find(item => {
          return item.date === fullDateStr;
        });
        tempWeekData.push({
          inCount: reuslt ? reuslt.reservationOrders.length : 0,
          month: tempDate.format("MM"),
          fullDate: fullDateStr,
          weekDesc:
            index === 0
              ? this.$t("base.today")
              : index === 1
              ? this.$t("base.tomorrow")
              : this.weekDescMap[tempDate.get("day")],
          day: tempDate.format("DD")
        });
      }
      this.weekDataList = tempWeekData;
    });
  }
  handleViewAllOrder() {
    let { href } = this.$router.resolve({
      path: `/service/index`
    });
    window.open(href, "_blank");
  }
  handleClickSomeday(dayData) {
    console.log(dayData, "dayData");

    this.currentLookDay = dayData.day;
    let { href } = this.$router.resolve({
      path: `/service/index?date=${dayData.fullDate}&type=all`
    });
    window.open(href, "_blank");
  }
  handleSwitchStatus(i) {
    this.currentStatus = i;
    // console.log(this.orderListData,"状态");
    //首页右侧时间描述
    this.taskList = this.orderListData[i].map(item => {
      item.showTimeDesc = item.completedTime
        ? this.$t("service.appointment-time")
        : item.arrivalTime
        ? this.$t("service.arrival-time")
        : this.$t("dashboard.created-time");
      item.showTime = item.completedTime || item.arrivalTime || item.receivedTime;
      return item;
    });
  }
  @Watch("$route")
  watchRoute(val) {
    if (val.path === "/index") {
      this.init();
    }
  }
}
